import dayjs from 'dayjs';
import Decimal from 'decimal.js';
import duration from 'dayjs/plugin/duration';
import { all, create } from 'mathjs';
// @ts-ignore
import { convertRate, irr, xirr } from 'node-irr';
import { getServerTime } from '@tencent/vb-web-base-core';
import { getUrlQuery } from '@common/utils/param';
Decimal.set({ precision: 14, defaults: true });
const math = create(all, {
    number: 'BigNumber',
    precision: 30, // Number of significant digits for BigNumbers
});
dayjs.extend(duration);
const now = getServerTime();
let start = dayjs.unix(now);
// uat测试用日期
const testStartDate = getUrlQuery('testStartDate');
if (testStartDate) {
    const tmp = dayjs(testStartDate);
    if (tmp.isValid()) {
        start = tmp;
    }
}
export function doTrialInterest(loanAmt, rate, term, trialDay) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const principal = math.round(math.evaluate(`${loanAmt} / ${term}`), 2);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const rateRaw = math.evaluate(`${rate} / 100`);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const repayDay = start.add(trialDay, 'd');
    const effectTerm = repayDay.diff(start, 'M');
    const remainDay = repayDay.diff(start.add(effectTerm, 'M'), 'd');
    let totalInterest = 0;
    let remainAmt = loanAmt;
    for (let index = 1; index <= effectTerm; index++) {
        const item = getInterest(loanAmt, rateRaw, effectTerm, index, principal);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        totalInterest = math.add(totalInterest, item.interest);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        remainAmt = math.subtract(remainAmt, principal);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const remainInterest = math.evaluate(`${remainDay} * ${remainAmt} * ${rateRaw}`);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    totalInterest = math.round(math.add(totalInterest, remainInterest), 2);
    return totalInterest.toFixed(2);
}
export function doCal(loanAmt, rate, term) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // 每期还款本金
    const principal = math.round(math.evaluate(`${loanAmt} / ${term}`), 2);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // 日利率
    const rateRaw = math.evaluate(`${rate} / 100`);
    const arr = [
        {
            amount: -loanAmt,
            date: start.format('YYYY-MM-DD'),
        },
    ];
    let totalInterest = 0;
    /** 平均日利息 */
    let averageDayInterest = -1;
    const plan = [];
    for (let index = 1; index <= term; index++) {
        const item = getInterest(loanAmt, rateRaw, term, index, principal);
        plan.push({
            // 每期还款金额
            installment: format2(item.installment),
            // 每期利息
            interest: format2(item.interest),
            // 每期还款本金
            principal: format2(item.periodPrcp),
            leftPrincipal: format2(item.leftPrincipal),
            // 还款日期
            date: item.date,
            day: item.day
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // 总利息
        totalInterest = math.add(totalInterest, item.interest);
        // totalAmt =  math.add(totalAmt, item.installment)
        arr.push({
            amount: +item.installment,
            date: item.date.format('YYYY-MM-DD'),
        });
    }
    const aprRaw = xirr(arr);
    const totalDay = diffDays(dayjs(arr[arr.length - 1].date), dayjs(arr[0].date));
    // @ts-ignore
    averageDayInterest = math.round(math.evaluate(`${totalInterest} /${totalDay}`), 2);
    // @ts-ignore
    const apr = math.round(convertRate(aprRaw.rate, 'year') * 100, 2).toString();
    console.log('totalInterest:' + totalInterest, 'totalDay:' + totalDay);
    return {
        plan,
        averageDayInterest,
        totalInterest: totalInterest.toFixed(2),
        totalDay,
        apr,
    };
}
// 等差数列求和
function sum(a, d, n) {
    return ((a + (a + (n - 1) * d)) * n) / 2; // （首项+末项）*项数/2
}
// 等额本息
export function doCalMonth(loanAmt, monthRate, term) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // 利率
    const rateRaw = math.evaluate(`${monthRate} /100`);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // 总还款利息
    const totalInterest = math.round(math.evaluate(`${loanAmt} * ${term} * ${rateRaw}`), 2);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // 每期还款金额
    const principal = math.round(math.evaluate(`(${+loanAmt} + ${totalInterest}) / ${term}`), 2);
    const sumRes = sum(1, 1, term);
    // 计算apr的数组
    const arr = [-loanAmt];
    const plan = [];
    for (let index = 1; index <= term; index++) {
        const item = getInterestMonth(loanAmt, totalInterest, term, index, principal, sumRes);
        plan.push({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // 每期还款金额
            installment: format2(principal),
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // 每期利息
            interest: format2(item.interest),
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // 每期还款本金
            principal: format2(item.periodPrcp),
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // 每期还款后剩余代还本金
            leftPrincipal: format2(item.leftPrincipal),
            // 还款日期
            date: item.date,
        });
        arr.push(+principal);
    }
    // 计算apr
    const irrRaw = irr(arr);
    console.log('irr', arr, irrRaw);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const aprRaw = math.subtract(math.dotPow(irrRaw + 1, 12), 1);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const apr = format2(aprRaw * 100).toString();
    return {
        plan,
        totalInterest: totalInterest.toFixed(2),
        apr,
    };
}
function format2(input) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return math.format(input, { notation: 'fixed', precision: 2 });
}
function diffDays(a, b) {
    return a.diff(b, 'd');
}
function getDays(term) {
    // 按实际天数算
    let firstDay = start.add(1, 'M');
    // 如果日期大于28日，则首次还款日为下下月1日
    if (start.date() >= 28) {
        firstDay = start.add(2, 'M').date(1);
    }
    const startDate = term === 1 ? start : firstDay.add(term - 2, 'M');
    const date = firstDay.add(term - 1, 'M');
    const day = date.diff(startDate, 'd');
    return {
        date,
        day,
    };
}
function getInterest(loanAmt, rate, term, currentTerm, principal) {
    const { day, date } = getDays(currentTerm);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const amt = math.evaluate(`${loanAmt} - (${currentTerm} -1) * (${principal})`);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const res = math.evaluate(`${amt} * ${rate} * ${day}`);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const interest = math.round(res, 2);
    const periodPrcp = currentTerm === term ? amt : principal;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const installment = math.add(interest, periodPrcp);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const leftAmt = math.evaluate(`${loanAmt} - (${currentTerm} -1) * (${principal})`);
    return {
        installment,
        interest,
        periodPrcp,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // 还款后剩余待还本金
        leftPrincipal: math.evaluate(`${leftAmt} - ${periodPrcp}`),
        date,
        day,
    };
}
function getInterestMonth(loanAmt, totalInterest, term, currentTerm, principal, sum) {
    const { date } = getDays(currentTerm);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // 本期利息
    const interest = math.round(math.evaluate(`${totalInterest} * (${term} - ${currentTerm} + 1) / ${sum}`), 2);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // 待还金额
    const leftAmt = math.evaluate(`${loanAmt} - (${currentTerm} -1) * (${principal}) - ${interest}`);
    // 本期还款金额
    const installment = principal;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // 需要还的本金
    const periodPrcp = math.evaluate(`${installment} - ${interest}`);
    return {
        installment,
        interest,
        periodPrcp,
        date,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // 还款后剩余待还本金
        leftPrincipal: math.evaluate(`${leftAmt} - ${periodPrcp}`),
    };
}
